import { Component, OnInit } from '@angular/core';
import {PostsService} from '../common/services/posts.service';
import {PostDO} from '../common/data-objects/PostDO';
import {ToastrService} from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-activities-page',
  templateUrl: './activities-page.component.html',
  styleUrls: ['./activities-page.component.scss']
})
export class ActivitiesPageComponent implements OnInit {
  posts: PostDO[];
  isLoading: boolean;
  page: number;
  searchText: string;
  pagesCount: number;
  itemsCount: number;
  private queryParamsSubscription: Subscription;

  constructor(
    private postsService: PostsService,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.seoService.setTitle('Jocuri biblice și activități online și offline - Fun Bible');
    this.seoService.setDescription('Jocuri biblice și activități creștine online și offline pe teme biblice pentru copii');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/activities/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/activities.png' });
    const initialKeywords = ['jocuri biblice', 'jocuri crestine', 'jocuri gratuite', 'jocuri de copii', 'jocuri ptr copii', 'jocuri online copii', 'activitati copii', 'diy', 'povestire biblica', 'origami', 'jocuri gratis'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Activities',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.page = Number(queryParams.get('page')) || 1;

      this.getData();
    });
  }

  search() {
    this.onPageChange(1);
  }

  onPageChange(page: number) {
    this.page = page;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.page
      },
      queryParamsHandling: 'merge',
    });
    this.getData();
  }

  getData() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }

    this.isLoading = true;
    this.postsService.getActivities(this.searchText, this.page).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }
}
